import { CSpinner } from "@coreui/react";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import {
  PG_BASE_URL,
  PG_WALLETKEY,
  PG_CLIENTKEY,
} from "src/_apiConfig/apiCall";

export default function GetResponse() {
  const formRef = useRef(null);
  const { id } = useParams();
  const [pgpath, setpgpath] = useState("");

  useEffect(() => {
    setpgpath(`${PG_BASE_URL}/UserRegister`);
    console.log("pgpath - 1"+ pgpath);
    const getDetails = async () => {
      // const header = new Headers();
      // header.append("Content-Type", "application/json");
      // header.append("Accept", "application/json");

      // const response = await apiCall(
      //   `LotDetails/getadhocpayments?$filter=lotId eq ${id} and amount eq ${amount}d`,
      //   "GET",
      //   header,
      //   null
      // );
      // const jsonobj = await response.json();
      // if (response.status === 200 && jsonobj.length > 0) {
      //   var txtID = makeid(15);
      //   var sessionID = jsonobj[0].code;
      //   const responseData = await apiCall(
      //     `LotDetails/getTransParams?txnId=${txtID}&sessionId=${sessionID}&amount=${jsonobj[0].amount}&returnUrl=http://localhost/CG_API1/api/Values&cancelUrl=http://localhost/CG_API1/api/Values`,
      //     // `LotDetails/getTransParams?txnId=${txtID}&sessionId=${sessionID}&amount=${jsonobj[0].amount}&returnUrl=${window.location.href}&cancelUrl=${window.location.href}`,
      //     "GET",
      //     header,
      //     null
      //   );
      //   const jsonobjData = await responseData.json();
      //   if (responseData.status === 200) {
      //     setchecksum(jsonobjData);
      formRef.current.submit();
      //   }
      // } else {
      //   var txtID = makeid(15);
      //   var sessionID = makeid(35);

      //   const responseData = await apiCall(
      //     `LotDetails/getTransParams?txnId=${txtID}&sessionId=${sessionID}&amount=${amount}&returnUrl=http://localhost/CG_API1/api/Values&cancelUrl=http://localhost/CG_API1/api/Values`,
      //     // `LotDetails/getTransParams?txnId=${txtID}&sessionId=${sessionID}&amount=${amount}&returnUrl=${window.location.href}&cancelUrl=${window.location.href}`,
      //     "GET",
      //     header,
      //     null
      //   );
      //   const jsonobjData = await responseData.json();
      //   if (responseData.status === 200) {
      //     setchecksum(jsonobjData);
      //     formRef.current.submit();
      //   }
      // }
    };
    getDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {id ? (
        <form
          method="post"
          ref={formRef}
          action={pgpath}
          //action="https://demo.b2biz.co.in/ws/walletAPI"
        >
          <input type="hidden" value="status" />
          <input type="hidden" value="WLT" />
          <input type="hidden" value={{ ["txn-id"]: id }} />
          <input
            type="hidden"
            value={PG_WALLETKEY}
            // value="MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCFdzI00N6VwjKuM6VCthI384NLqDQcY4vLl69Ug1GA02pfybm0JvgWFP0UGcfZ0ODeVuxvYwluCoGYIGwI/whwXpSf54kjFlDLMBTdu1z2F5HmeLGq2iTcbEnvdAoAW7YV4qcKnebPJGtarxxwGsRDC4Pwua+Yvn0wnGnyVEGVswIDAQAB"
          />
          <input
            type="hidden"
            value={PG_CLIENTKEY}
            // value="MIICeAIBADANBgkqhkiG9w0BAQEFAASCAmIwggJeAgEAAoGBAKHcS8E2pRH2CXjYL4a+soKezwED9blHeCy3DMpxt3LsPAuqluX+87sWn7ERpAvShAdALKmS9cUoSoHmWNFi+1JomMbUnXR5Ausj06Viyesuos/gKu/Od5twd4Ucv1V8u50tIH6NzKRwRUmHNsh8ovI/khpNVytvJZWsEUWbjiptAgMBAAECgYEAgs5Ifl3N6wT9xKZZSjikhMEYo0Zy94fVi7Vm5dgenAZjxD3ZcwemKwTuiyepflBjmIR5U5VLf0i/Zdkk4Bpw5XAgAldQYmVqeOsTtJSUFHCukzYo0CqXKC74UfA9obbdI87Eim+rqt9Ez0jgtf1amwkvpYGXrdHvyPTU9wLd0BUCQQDS5xPT4pV6/eJK+6qN1/R12x080YoqOA989pHZd2RB5GKzHbGQQNd/Wt0Dxu9oXyLSeha1HwRu5+CcQyatfqhTAkEAxHigiX377A8MT1/GjPXnLGJjB9RGOLMr42pJPo5OALt7A8j+w/LoUZVsSaqK5V3lJjEaCl9p06m6bwWbJgKKPwJBAJJVAszhShYsUfb050HDtTqQ7ZhlSxhADX8HFetti4KslE7zK2CLnPogcXlNbo9ccyzWySqietD40j+Z2BxI5UECQQCkIJEbyt8VCE0kUcIwJ4yDC33nIHG5FBRp2nRtibun6PaO5u3NC7L/1G+t6oY1rgarrQEwAR0K8RMJhAlj62NJAkAi4g4p+liTxw/F0rCEJPG2tOqgXN21cVbP9oOzHncGkmbqIZcXnskxibZX9x7f5MvotVtJVaJTBuiDUq4GQA+X"
          />
        </form>
      ) : (
        <CSpinner
          className="spinner-grow col-6 offset-6 mt-6"
          color="success"
        />
      )}
    </>
  );
}
